export default __webpack_public_path__ + "media/images/logos/monitoring-e1236f00de681119987b5dc305ac9b39.svg";